<template>
  <div class="service-type-page service-type-page--edit">

    <section class="service-type-page__header">
      <div class="service-type-page__header-icon">
        <i class="fas fa-pen" aria-hidden="true"></i>
      </div>
      <div>
        <span>KLASIFIKASI LAYANAN</span>
        <h1>Edit tipe layanan</h1>
        <p>Perbarui nama dan deskripsi tipe layanan tanpa mengubah relasi produk.</p>
      </div>
    </section>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card class="service-type-page__card" v-bind:title="'Informasi tipe layanan'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              :route="'payment-category-types/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/payment-category-types/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: "",
        description:"",
      },
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('payment-category-types/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/masters/payment-category-types/list')
      } else {
        if (this.form.is_system) {
          this.$router.replace('/masters/payment-category-types/detail/' + this.form.id)
          return
        }
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
     { title: "Tipe Produk Layanan", route: "" },
      { title: "Daftar Tipe Produk Layanan", route: "/masters/payment-category-types/list" },
      { title: "Ubah" },
    ])
    // Get Data
    this.get()
  },

}

</script>
